import React, { useEffect, useState } from 'react'
import Cookie from 'js-cookie'
import { Route, Redirect } from 'react-router-dom'
import axiosInstance from '../api/axios.instance'
import AppLoader from '../shared/ui/AppLoader'

const LicensorsRoute = ({ component: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthorized, setIsAuthorized] = useState(false)
  const accessToken = Cookie.get('vb-access-token')

  useEffect(() => {
    const checkLicensorsAccess = async () => {
      // Если нет токена - тихий редирект на логин без уведомлений
      if (!accessToken) {
        setIsLoading(false)
        setIsAuthorized(false)
        return
      }

      try {
        const { data } = await axiosInstance.post('/auth/authenticate')
        
        if (data?.code === 200) {
          // Разрешаем доступ для author, admin и output editor
          if (data.apiData.role === 'author' || data.apiData.role === 'admin' || data.apiData.role === 'output editor') {
            setIsAuthorized(true)
          } else {
            setIsAuthorized(false)
          }
        } else {
          setIsAuthorized(false)
        }
      } catch (err) {
        // При любых ошибках - тихий редирект без уведомлений
        console.log('Licensors access check error:', err)
        
        if (err.response?.data?.code === 401) {
          // Токен истек - удаляем токены и делаем тихий редирект
          Cookie.remove('vb-refresh-token')
          Cookie.remove('vb-access-token')
        }
        
        setIsAuthorized(false)
      } finally {
        setIsLoading(false)
      }
    }

    checkLicensorsAccess()
  }, [accessToken])

  if (isLoading) {
    // Показываем загрузку пока проверяем доступ
    return (
      <AppLoader />
    )
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!accessToken || !isAuthorized) {
          // Нет токена или не авторизован - тихий редирект на логин
          return <Redirect to="/login" />
        }
        
        // Пользователь авторизован - показываем компонент
        return <Component {...props} />
      }}
    />
  )
}

export default LicensorsRoute
